import gql from 'graphql-tag'

export const billingInfoUpdate = gql`
  mutation BillingInfoUpdate($deviceId: ID!, $billingInfo: BillingInfoInput!) {
    billingInfoUpdate(input: { deviceId: $deviceId, billingInfo: $billingInfo }) {
      success
      billingInfo {
        firstName
        lastName
        company
        email
        phone
        country
        street
        streetNumber
        apartmentNumber
        zipCode
        city
        vat
        invoiceLang
        companyId
      }
    }
  }
`
